import { JurisdictionsEnum } from '@libs/backend-common';
import { AppLangCode } from '@libs/types';
export const LANG_KEY = 'language';
export const getPreselectedLanguageCode = (jurisdictionId) => {
    let defaultLanguageCode = localStorage.getItem(LANG_KEY);
    const isGlobal = [JurisdictionsEnum.EU, JurisdictionsEnum.UA].includes(jurisdictionId);
    if (defaultLanguageCode) {
        if ((defaultLanguageCode !== AppLangCode.EN &&
            jurisdictionId === JurisdictionsEnum.EU) ||
            (defaultLanguageCode === AppLangCode.KA &&
                jurisdictionId === JurisdictionsEnum.UA)) {
            defaultLanguageCode = AppLangCode.EN;
        }
        return { defaultLanguageCode };
    }
    else {
        defaultLanguageCode = isGlobal ? AppLangCode.EN : AppLangCode.KA;
    }
    return { defaultLanguageCode };
};
//# sourceMappingURL=getPreseletedLanguageCode.js.map